export default "__VITE_ASSET__CHbSngWb__"